import calculateScheduledDistribution, {
  clearScheduledDistributionMemo,
} from '../../Impounds/helpers/calculateScheduledDistribution';
import getCalculatedBalance from './getCalculatedBalance';

const createFinalBalance = ({
  twelveMonthsInvoices,
  initialImpoundBalance,
  adjustment,
  totalMonthlyImpoundPayment,
  bills,
}) => {
  let prevValue = initialImpoundBalance + adjustment;

  const finalBalances = twelveMonthsInvoices.map((invoice) => {
    const { sum: distribution } = calculateScheduledDistribution({
      row: invoice,
      bills,
      shouldReturnRawValue: true,
    });

    const value = prevValue + +totalMonthlyImpoundPayment - distribution;

    prevValue = value;
    return value;
  });

  clearScheduledDistributionMemo();

  return finalBalances;
};

export default function getImpoundAnalysisTableData({
  invoices,
  startingInvoiceIndex,
  totalMonthlyImpoundPayment,
  bills,
  initialImpoundBalance,
  adjustment,
}) {
  const twelveMonthsInvoices = invoices
    .filter(
      (invoice) => invoice.sequence !== 'PROJECTED' && invoice.sequence !== ''
    )
    ?.slice(startingInvoiceIndex, startingInvoiceIndex + 12);

  const calculatedBalance = getCalculatedBalance({
    invoices,
    startingInvoiceIndex,
    initialImpoundBalance,
    totalMonthlyImpoundPayment,
    bills,
  });

  const finalBalances = createFinalBalance({
    twelveMonthsInvoices,
    initialImpoundBalance,
    adjustment,
    totalMonthlyImpoundPayment,
    bills,
  });

  const rows = twelveMonthsInvoices.map((invoice, index) => {
    return {
      period: invoice.date,
      impoundPayments: totalMonthlyImpoundPayment,
      distribution: calculateScheduledDistribution({
        row: invoice,
        bills,
      }).sum,
      description: invoice.description,
      descriptionData: invoice.descriptionData,
      calculatedBalance: calculatedBalance[index],
      finalBalance: finalBalances[index] ? finalBalances[index].toFixed(2) : '',
      // style: 'align-top',
    };
  });

  clearScheduledDistributionMemo();

  return rows;
}
